import script from "./AdviceCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./AdviceCarousel.vue?vue&type=script&setup=true&lang=js"

import "./AdviceCarousel.vue?vue&type=style&index=0&id=5d2600f5&scoped=true&lang=scss"

import exportComponent from "D:\\Dev\\ClimEco\\Django\\ClimEco\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d2600f5"]])

export default __exports__